import React, { useEffect, useState } from "react";
import { TrashIcon } from "@heroicons/react/24/solid";
import { FilterPreview } from "./filters";

interface FilterCategoryProps {
  image: any;
  setFilter: (filter: string | null) => void;
  filter: string | null;
  categoryFilters: string[];
}

export const FilterCategory = ({
  image,
  setFilter,
  filter,
  categoryFilters,
}: FilterCategoryProps) => {
  const [selectedFilter, setSelectedFilter] = useState<string | null>(filter);
  const [imageElement, setImageElement] = useState<HTMLImageElement | null>(
    null
  );

  // Load the image
  useEffect(() => {
    if (image?.url) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        setImageElement(img);
      };
      img.src = image.url;
    }
  }, [image?.url]);

  // Sync selectedFilter with filter prop
  useEffect(() => {
    setSelectedFilter(filter);
  }, [filter]);

  const handleFilterSelect = (filterName: string) => {
    if (selectedFilter === filterName) {
      // If clicking on the same filter, remove it (go back to original)
      setSelectedFilter(null);
      setFilter(null);
    } else {
      // Otherwise select the new filter
      setSelectedFilter(filterName);
      setFilter(filterName);
    }
  };

  return (
    <div className="grid grid-cols-3 gap-2">
      {categoryFilters.map((filterName) => (
        <div
          key={filterName}
          className={`cursor-pointer rounded-lg transition-all relative group ${
            selectedFilter === filterName
              ? "ring-2 ring-blue-500 ring-offset-2 ring-offset-white dark:ring-offset-gray-800"
              : "hover:opacity-80"
          }`}
          onClick={() => handleFilterSelect(filterName)}
        >
          {/* Trash icon overlay - shows only when this filter is selected and on hover */}
          {selectedFilter === filterName && (
            <div className="absolute top-1 right-1 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="bg-red-500 rounded-full p-1">
                <TrashIcon className="w-3 h-3 text-white" />
              </div>
            </div>
          )}
          <div className="aspect-[1/1] rounded-lg overflow-hidden mb-1">
            {imageElement && (
              <FilterPreview
                imageElement={imageElement}
                filterName={filterName}
                className="w-full h-full object-cover"
              />
            )}
          </div>
          <p className="text-xs text-center font-medium px-1 truncate">
            {filterName}
          </p>
        </div>
      ))}
    </div>
  );
};
